import {ref, watch} from "vue";
import _ from 'lodash'

export function useReportOutput(props) {
    const v = ref()
    const extra = ref(null)

    watch(() => props.value, (n) => {
        if (_.isObject(props.value)) {
            v.value = props.value.display
            extra.value = props.value?.extra
        }

    }, {immediate: true})

    return {v, extra}
}